import React from "react";
import { Box, Select, MenuItem, InputLabel, FormControl } from "@mui/material";

const MonthYearSelector = ({
  selectedMonth,
  selectedYear,
  onMonthChange,
  onYearChange,
}) => {
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const years = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i >= 2000; i--) {
    years.push(i);
  }

  return (
    <Box display="flex" gap="16px">
      <FormControl>
        <InputLabel id="month-select-label">Month</InputLabel>
        <Select
          labelId="month-select-label"
          id="month-select"
          value={selectedMonth}
          onChange={(e) => onMonthChange(e.target.value)}
          sx={{ width: "100px" }}
          label="Age"
        >
          <MenuItem value="" disabled>
            Select Month
          </MenuItem>
          {months.map((month) => (
            <MenuItem key={month.value} value={month.value}>
              {month.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl>
        <InputLabel id="year-select-label">Year</InputLabel>

        <Select
          labelId="year-select-label"
          id="year-select"
          value={selectedYear}
          onChange={(e) => onYearChange(e.target.value)}
          label="Year"
          sx={{ width: "100px" }}
        >
          <MenuItem value="" disabled>
            Select Year
          </MenuItem>
          {years.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default MonthYearSelector;
